import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppSettings, defaults } from '../app.config';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANGUAGE, SITE_LANGUAGES, STORAGE_KEY } from '../shared/constants';

@Injectable({
  providedIn: 'root',
})
export class CoreService {

  constructor(private translateService: TranslateService) { }

  get notify(): Observable<Record<string, any>> {
    return this.notify$.asObservable();
  }

  private notify$ = new BehaviorSubject<Record<string, any>>({});

  getOptions() {
    return this.options;
  }

  setOptions(options: AppSettings) {
    this.options = Object.assign(defaults, options);
    this.notify$.next(this.options);
  }

  private options = defaults;

  getUserLanguage(): any {
    const userLangCode = localStorage.getItem(STORAGE_KEY.USER_LANGUAGE) || DEFAULT_LANGUAGE;
    return SITE_LANGUAGES.find(lang => lang.code === userLangCode);
  }

  getTheme(): any {
    return localStorage.getItem(STORAGE_KEY.THEME);
  }
  
  setTheme(theme: string) {
    localStorage.setItem(STORAGE_KEY.THEME, theme);
  }

  initTranslate() {
    const languageCodes = SITE_LANGUAGES.map((lang) => lang.code);
    const langCode = localStorage.getItem(STORAGE_KEY.USER_LANGUAGE) || DEFAULT_LANGUAGE;
    this.translateService.addLangs(languageCodes); // to work on deploy
    this.translateService.setDefaultLang(DEFAULT_LANGUAGE);
    this.translateService.use(langCode);
  }
}
